import { createUser } from "../../services/user.services";

export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";

export const createNewUser = (userData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CREATE_USER_REQUEST });

    const { data } = await createUser(
      userData,
      JSON.parse(sessionStorage.getItem("myData"))
    );

    dispatch({
      type: CREATE_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_USER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
